import { SignIn } from "@clerk/clerk-react";
import { adminPublicAuthAppearance } from "../clerkAppearance";

/**
 * Public entry: centered sign-in only (no app chrome). Authenticated users use AppShell routes.
 */
export function AdminLanding() {
  return (
    <div
      style={{
        minHeight: "100%",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "clamp(1.25rem, 4vw, 2rem)",
        background:
          "radial-gradient(90% 70% at 50% 0%, rgba(34, 211, 187, 0.12) 0%, transparent 55%), radial-gradient(80% 50% at 100% 100%, rgba(42, 51, 68, 0.85) 0%, transparent 45%), var(--sd-bg)",
      }}
    >
      <header style={{ textAlign: "center", marginBottom: "1.5rem", maxWidth: "22rem" }}>
        <div style={{ fontWeight: 800, fontSize: "1.5rem", letterSpacing: "-0.04em" }}>SurgeDial</div>
        <p style={{ margin: "0.35rem 0 0", fontSize: "0.9rem", color: "var(--sd-muted)", fontWeight: 500 }}>
          Platform Admin Login
        </p>
      </header>

      <div
        style={{
          width: "100%",
          maxWidth: "24rem",
          minWidth: 0,
        }}
      >
        <SignIn routing="virtual" signUpUrl="/sign-up" appearance={adminPublicAuthAppearance} />
      </div>
    </div>
  );
}
